<template>
  <ul class="sns-list">
    <li v-for="sns in snsListComp" :key="sns.id" class="sns-list-item">
      <sns-item
        :id="sns.id"
        :type="sns.type"
        :title="sns.title"
        :connection-date="sns.connectionDate"
        :is-connection="sns.isConnection"
        :button-text="sns.buttonText"
        @connect="$emit('connect', $event)"
        @disconnect="$emit('disconnect', $event)"
      />
    </li>
  </ul>
</template>

<script setup>
  import SnsItem from '@/components/connection/sns/SnsItem.vue'
  import { computed } from 'vue'
  import { PROVIDER_LIST } from '@/common/resources/const'

  const props = defineProps({
    snsList: {
      type: Array,
      default: () => [],
    },
  })
  const emit = defineEmits(['connect', 'disconnect'])

  const snsListComp = computed(() => {
    return props.snsList.map((sns) => {
      const provider = PROVIDER_LIST.find((provider) => {
        return provider.id === sns.providerId
      })
      return {
        id: sns.providerId,
        type: provider.type,
        title: provider.title,
        connectionDate: sns.connectionDate,
        isConnection: sns.state,
        buttonText: sns.stateText || (sns.state ? '연결 해제' : '연결하기'),
      }
    })
  })
</script>

<style lang="scss" scoped>
  .sns-list {
    overflow: hidden;
    border: 1px solid #2f2f2f;
    border-radius: 8px;
    & > li {
      border-top: 1px solid #2f2f2f;
      padding: 20px 16px;
    }
    & > li:first-child {
      border-top: 0;
    }
  }
</style>
